var e = Object.defineProperty,
  t = Object.getOwnPropertySymbols,
  r = Object.prototype.hasOwnProperty,
  o = Object.prototype.propertyIsEnumerable,
  s = (t, r, o) => r in t ? e(t, r, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: o
  }) : t[r] = o,
  i = (e, i) => {
    for (var n in i || (i = {})) r.call(i, n) && s(e, n, i[n]);
    if (t) for (var n of t(i)) o.call(i, n) && s(e, n, i[n]);
    return e;
  };
import { Controller as n } from "stimulus";
import p from "swiper/bundle";
class l extends n {
  connect() {
    this.swiper = new p(this.element, i(i({}, this.defaultOptions), this.optionsValue));
  }
  disconnect() {
    this.swiper.destroy(), this.swiper = void 0;
  }
  get defaultOptions() {
    return {};
  }
}
l.values = {
  options: Object
};
export { l as default };